const Instagram = (props: SocialIconProps) => {
  const { className } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" className={className}>
      <rect
        width={62}
        height={62}
        x={1}
        y={1}
        rx={31}
        strokeWidth={2}
        className="fill-surface-secondary stroke-skin-stroke"
      />
      <path
        className="fill-skin-primary"
        fillRule="evenodd"
        d="M25.95 17.42c1.57-.07 2.07-.09 6.05-.09s4.48.02 6.04.1c1.57.06 2.64.31 3.57.67a7.2 7.2 0 0 1 2.6 1.7 7.16 7.16 0 0 1 1.69 2.6c.36.93.6 2 .68 3.55.07 1.57.09 2.07.09 6.05s-.02 4.48-.1 6.05a10.73 10.73 0 0 1-.67 3.56 7.2 7.2 0 0 1-1.7 2.6 7.2 7.2 0 0 1-2.6 1.68c-.92.37-2 .62-3.55.69-1.57.07-2.07.09-6.05.09s-4.48-.02-6.05-.1a10.76 10.76 0 0 1-3.56-.67 7.2 7.2 0 0 1-2.6-1.7 7.19 7.19 0 0 1-1.69-2.6c-.36-.93-.6-2-.68-3.55-.07-1.57-.09-2.07-.09-6.05s.02-4.48.1-6.05c.06-1.56.31-2.63.67-3.56a7.2 7.2 0 0 1 1.7-2.6 7.19 7.19 0 0 1 2.6-1.69c.93-.36 2-.6 3.55-.68zm11.98 2.64c-1.55-.07-2.01-.08-5.93-.08s-4.38.01-5.93.08a8.3 8.3 0 0 0-2.72.5 4.56 4.56 0 0 0-1.69 1.1 4.55 4.55 0 0 0-1.1 1.69c-.2.52-.43 1.3-.5 2.72-.07 1.55-.08 2.01-.08 5.93s.01 4.38.08 5.93c.07 1.43.3 2.2.5 2.72a4.75 4.75 0 0 0 2.79 2.79c.52.2 1.3.43 2.72.5 1.55.07 2.01.08 5.93.08s4.38-.01 5.93-.08a8.3 8.3 0 0 0 2.72-.5 4.55 4.55 0 0 0 1.69-1.1 4.55 4.55 0 0 0 1.1-1.69c.2-.52.43-1.3.5-2.72.07-1.55.08-2.01.08-5.93s-.01-4.38-.08-5.93a8.14 8.14 0 0 0-.5-2.72 4.55 4.55 0 0 0-1.1-1.69 4.55 4.55 0 0 0-1.69-1.1c-.52-.2-1.3-.43-2.72-.5zm-7.8 16.46a4.9 4.9 0 0 0 5.33-7.98 4.9 4.9 0 0 0-8.3 2.74 4.9 4.9 0 0 0 2.97 5.24zm-3.46-9.85a7.54 7.54 0 0 1 12.3 2.45 7.54 7.54 0 1 1-12.3-2.45zm14.54-1.08a1.78 1.78 0 0 0-.55-2.95 1.78 1.78 0 1 0 .55 2.95z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default Instagram;
